import task_management from './task_management/router'

export default [{
    path: 'task',
    name: 'task',
    component: r => require.ensure([], () => r(require('./index.vue')), 'task'),
    children: [
        task_management,
    ]
}]
